import React, { useContext, useEffect, useRef } from "react";
import { AppContext } from "../Redux/ContextProvider";
import Breadcrumb from "../Generic/Breadcrumb";
import { ClipLoader } from "react-spinners";
import EventsDisplay from "./EventsDisplay";
import { getCommonDetails } from "../Redux/API";

function MyEvents() {
  const { appState, dispatch } = useContext(AppContext);
  const { common, loginLoader } = appState;
  const myRef = useRef(null);

  const registered_event_list =
    common?.data?.registered_event_list ||
    common?.registered_event_list ||
  [];

  useEffect(() => {
    const customer_id = localStorage.getItem("CustomerId");

    if (!customer_id) {
      return;
    }

    getCommonDetails(appState, dispatch, customer_id);
  }, []);

  return (
    <>
      {loginLoader ? (
        <div className="home-spinner">
          <ClipLoader color="#2A5350" size={50} />
        </div>
      ) : (
        <>
          <Breadcrumb
            pageName="My Events"
            pageTitle="My Events"
            myRef={myRef}
          />

          {registered_event_list?.length > 0 ? (
            <div ref={myRef}>
              <EventsDisplay data={registered_event_list} />
            </div>
          ) : (
            <div className="pt-50 pb-50 text-center">
              No events found
            </div>
          )}
        </>
      )}
    </>
  );
}

export default MyEvents;